import Hero from '../components/home/Hero';
import USPBar from '../components/home/USPBar';
import FeaturedDishes from '../components/home/FeaturedDishes';
import AboutTeaser from '../components/home/AboutTeaser';
import Testimonials from '../components/home/Testimonials';
import LocationHours from '../components/home/LocationHours';
import ReservationCTA from '../components/home/ReservationCTA';

export default function Home() {
  return (
    <>
      <Hero />
      <USPBar />
      <FeaturedDishes />
      <AboutTeaser />
      <Testimonials />
      <LocationHours />
      <ReservationCTA />
    </>
  );
}
